import { userBlocFactory } from './chunk-3YUX7DFB.mjs';
export { userBlocFactory, userOutputSchema as userSchema } from './chunk-3YUX7DFB.mjs';
import { firestore } from './chunk-CBPAVK33.mjs';

// src/user.ts
var userBloc = userBlocFactory({ db: firestore });

export { userBloc };
//# sourceMappingURL=user.mjs.map
//# sourceMappingURL=user.mjs.map